module.exports = __webpack_public_path__ + "static/NetSup_Verizon-54614a9b0c518c9477f539d380480428.mp4";